import { render } from "./likeButton.vue?vue&type=template&id=573398a4"
import script from "./likeButton.vue?vue&type=script&lang=js"
export * from "./likeButton.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__